<template>
  <section class="manage-report">
    <!-- search area -->
    <table>
      <caption>URL Search</caption>
      <tr>
        <td colspan="2">
          <table class="tbl_search">
            <colgroup>
              <col style="width: 250px;" />
              <col style="width: 120px;" />
              <col style="width: 130px;" />
              <col style="width: 130px;" />
              <col style="width: 100px;" />
              <col style="" />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">진단 시각</th>
                <th scope="col">진단 로딩 시간</th>
                <th scope="col">오류 여부</th>
                <th scope="col">계정</th>
                <th scope="col">저장 여부</th>
                <th scope="col">그룹명</th>
                <th scope="col">페이지명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="date-range-box">
                  <date-picker placeholder="yyyy.mm.dd" input-class="input-date"
                    lang="en"
                    v-model="startDate"
                    format="YYYY.MM.DD"
                    @input="onStartDateChanged" />
                  <span class="h-bar"></span>
                  <date-picker placeholder="yyyy.mm.dd" input-class="input-date"
                    lang="en"
                    v-model="endDate"
                    format="YYYY.MM.DD"
                    @input="onEndDateChanged" />
                </td>
                <td><input type="number" id="sec_load" name="sec_load" style="width: 54px;" class="mg-right"
                  v-model.trim="model.runSeconds" />초 이상</td>
                <td>
                  <input type="checkbox" id="error" name="error" class="mg-right"
                    v-model="model.failureOnly" /><label for="error">Fail</label>
                  <input type="checkbox" id="pass" name="pass" class="mg-right mg-left"
                    v-model="model.successOnly" /><label for="pass">Success</label>
                </td>
                <td><input type="text" id="account" name="account" class="input-full"
                  v-model.trim="model.email" /></td>
                <td style="padding-left: 15px;">
                  <input type="checkbox" id="save_yes" name="save_yes" class="mg-right"
                    v-model="model.isReport" /><label for="save_yes">Y</label>
                  <input type="checkbox" id="save_no" name="save_no" class="mg-right mg-left"
                    v-model="model.isTempReport" /><label for="save_no">N</label>
                </td>
                <td><input type="text" id="group" name="group" class="input-full"
                  v-model.trim="model.groupName" /></td>
                <td><input type="text" id="page" name="page" class="input-full"
                  v-model.trim="model.title" /></td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <table class="tbl_search">
            <colgroup>
              <col style="width: 260px;" />
              <col style="width: 130px;" />
              <col style="width: 197px;" />
              <col style="width: 197px;" />
            </colgroup>
            <thead>
              <th scope="col">URL</th>
              <th scope="col">해상도</th>
              <th scope="col">로그인 설정여부</th>
              <th scope="col">제외할 요소 설정여부</th>
            </thead>
            <tbody>
              <td><input type="text" id="url" name="url" class="input-full"
                v-model.trim="model.url" /></td>
              <td>
                <input type="checkbox" id="res_pc" name="res_pc" class="mg-right"
                  v-model="model.isDesktopDevice" /><label for="res_pc">Desktop</label>
                <input type="checkbox" id="res_m" name="res_m" class="mg-right mg-left"
                  v-model="model.isMobileDevice" /><label for="res_m">Mobile</label>
              </td>
              <td>
                <input type="checkbox" id="login_yes" name="login_yes" class="mg-right"
                  v-model="model.requireLogin" /><label for="login_yes">Y</label>
                <input type="checkbox" id="login_no" name="login_no" class="mg-right mg-left"
                  v-model="model.notRequireLogin" /><label for="login_no">N</label><span class="v-bar">|</span>
                <input type="checkbox" id="login_detail" name="login_detail" class="mg-right"
                  v-model="showLoginDetail" /><label for="login_detail">상세정보 보기</label>
              </td>
              <td>
                <input type="checkbox" id="except_yes" name="except_yes" class="mg-right"
                  v-model="model.useExcludeSelectors" /><label for="except_yes">Y</label>
                <input type="checkbox" id="except_no" name="except_no" class="mg-right mg-left"
                  v-model="model.notUseExcludeSelectors" /><label for="except_no">N</label><span class="v-bar">|</span>
                <input type="checkbox" id="except_detail" name="except_detail" class="mg-right"
                  v-model="showExcludeSelectorsDetail" /><label for="except_detail">상세정보 보기</label>
              </td>
            </tbody>
          </table>
        </td>
        <td class="btn"><button type="button" class="btn_search" @click="onSearchClick">SEARCH</button></td>
      </tr>
    </table>

    <!-- result area -->
    <div class="result_wrap">
      <table class="tbl_result">
        <caption>URL search result</caption>
        <thead>
          <tr>
            <th scope="col" style="width: 160px;"><a href="#" :class="getSortClass('runAt')"
              @click.prevent="setSort('runAt')">진단요청시각</a></th>
            <th scope="col" style="width: 120px;"><a href="#" :class="getSortClass('runSeconds')"
              @click.prevent="setSort('runSeconds')">진단로딩시간(초)</a></th>
            <th scope="col" style="width: 120px;"><a href="#" :class="getSortClass('isSuccess')"
              @click.prevent="setSort('isSuccess')">오류여부</a></th>
            <th scope="col" style="width: 190px;"><a href="#" :class="getSortClass('statusCode')"
              @click.prevent="setSort('statusCode')">오류원인</a></th>
            <th scope="col" style="width: 210px;"><a href="#" :class="getSortClass('email')"
              @click.prevent="setSort('email')">계정</a></th>
            <th scope="col" style="width: 100px;"><a href="#" :class="getSortClass('isSaved')"
              @click.prevent="setSort('isSaved')">저장여부</a></th>
            <th scope="col" style="width: 120px;"><a href="#" class="">리포트 링크</a></th>
            <th scope="col" style="width: 150px;"><a href="#" :class="getSortClass('groupName')"
              @click.prevent="setSort('groupName')">그룹명</a></th>
            <th scope="col" style="width: 150px;"><a href="#" :class="getSortClass('title')"
              @click.prevent="setSort('title')">페이지명</a></th>
            <th scope="col" style="width: 150px;"><a href="#" :class="getSortClass('url')"
              @click.prevent="setSort('url')">URL</a></th>
            <th scope="col" style="width: 130px;"><a href="#" :class="getSortClass('deviceType')"
              @click.prevent="setSort('deviceType')">해상도</a></th>
            <th scope="col" style="width: 130px;"><a href="#" :class="getSortClass('requireLogin')"
              @click.prevent="setSort('requireLogin')">로그인 설정여부</a></th>
            <template v-if="showLoginDetail">
              <th scope="col" style="width: 140px;"><a href="#" class="">로그인 URL</a></th>
              <th scope="col" style="width: 140px;"><a href="#" class="">ID Selector</a></th>
              <th scope="col" style="width: 140px;"><a href="#" class="">PW Selector</a></th>
              <th scope="col" style="width: 150px;"><a href="#" class="">Button Selector</a></th>
              <th scope="col" style="width: 130px;"><a href="#" class="">ID Value</a></th>
            </template>
            <th scope="col" style="width: 135px;"><a href="#" :class="getSortClass('useExcludeSelectors')"
              @click.prevent="setSort('useExcludeSelectors')">제외요소 설정여부</a></th>
            <template v-if="showExcludeSelectorsDetail">
              <th scope="col" style="width: 135px;"><a href="#" class="">제외요소 목록개수</a></th>
              <th scope="col" style="width: 230px;"><a href="#" class="">제외요소목록</a></th>
            </template>
          </tr>
        </thead>
        <tbody v-if="hasReport">
          <tr v-for="item in reports" :key="`${item.id}-${item.isSaved}`">
            <td>{{ item.runAt | yymmddhhmmss }}</td>
            <td>{{ item.runSeconds }}</td>
            <td>{{ item.isSuccess ? 'Success' : 'Fail' }}</td>
            <td>
              <p v-if="item.errorData">
                <span>{{ item.errorData.name }}</span>
                <span class="ico_tooltip"><img src="../../../src/assets/images/ico_tooltip.png" alt="View description">
                  <span class="tooltip">{{ item.errorData.description }}</span></span>
              </p>
              <template v-else>-</template>
            </td>
            <td>{{ item.email }}</td>
            <td>{{ item.isSaved | yesOrNo }}</td>
            <td>
              <template v-if="!item.isSuccess">
                -
              </template>
              <template v-else-if="item.isSaved">
                <router-link :to="{ name: 'Report', params: { id: item.id }}"
                  class="btn_view">View</router-link>
              </template>
              <template v-else>
                <router-link :to="{ name: 'TempReport', params: { id: item.id }}"
                  class="btn_view">View</router-link>
              </template>
            </td>
            <td>{{ item.groupName | emptyChar }}</td>
            <td>{{ item.title | emptyChar }}</td>
            <td class="left">{{ item.url }}</td>
            <td>{{ item.device }}</td>
            <td>{{ item.requireLogin | yesOrNo }}</td>
            <template v-if="showLoginDetail">
              <td :class="item.loginUrl ? 'left' : ''">{{ item.loginUrl | emptyChar }}</td>
              <td>{{ item.loginIdSelector | emptyChar }}</td>
              <td>{{ item.loginPasswordSelector | emptyChar }}</td>
              <td>{{ item.loginButtonSelector | emptyChar }}</td>
              <td>{{ item.loginId | emptyChar }}</td>
            </template>
            <td>{{ item.useExcludeSelectors | yesOrNo }}</td>
            <template v-if="showExcludeSelectorsDetail">
              <td>{{ item.excludeSelectorsCount | emptyChar }}</td>
              <td>{{ item.excludeSelectors | emptyChar }}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-if="!hasReport" class="no-results">No results</p>

    <!-- paging -->
    <app-paging v-if="paging.total"
      :paging="paging"
      @onPageChange="onPageChange" />
  </section>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import AppPaging from '@/components/global/AppPaging'
import ajaxHandlerMixin from '@/mixins/ajax-handler'
import adminApi from '@/api/admin'

export default {
  name: 'ManageReport',
  mixins: [ajaxHandlerMixin],
  components: {
    DatePicker,
    AppPaging
  },
  data () {
    return {
      startDate: null,
      endDate: null,
      searchOptions: {},
      reports: [],
      defaultModel: null,
      model: {
        runAt: null,
        finishedAt: null,
        runSeconds: 0,
        successOnly: true,
        failureOnly: true,
        email: null,
        isTempReport: true,
        isReport: true,
        groupName: null,
        title: null,
        url: null,
        isDesktopDevice: true,
        isMobileDevice: true,
        requireLogin: true,
        notRequireLogin: true,
        useExcludeSelectors: true,
        notUseExcludeSelectors: true,
        page: 1,
        limit: 10,
        total: 0,
        sortColumn: 'runAt',
        sortOrder: 'ASC'
      },
      showLoginDetail: false,
      showExcludeSelectorsDetail: false
    }
  },
  computed: {
    hasReport () {
      return this.reports && this.reports.length
    },
    paging () {
      return {
        page: this.model.page,
        limit: this.model.limit,
        total: this.model.total
      }
    }
  },
  created () {
    this.defaultModel = Object.assign({}, this.model)

    if (this.$route.query) {
      this.model = Object.assign({}, this.model, this.$route.query)
    }

    if (this.model.runAt) {
      this.startDate = moment(this.model.runAt).toDate()
    }
    if (this.model.finishedAt) {
      this.endDate = moment(this.model.finishedAt).toDate()
    }

    this.searchOptions = Object.assign({}, this.model)
    this.fetchReport()
  },
  watch: {
    '$route.query' (to, from) {
      this.model = Object.assign({}, this.defaultModel, to)
      this.searchOptions = Object.assign({}, this.model)
      this.fetchReport()
    }
  },
  methods: {
    fetchReport () {
      adminApi.findReports(this.searchOptions).then(response => {
        this.reports = response.data.items
        this.model = Object.assign({}, this.searchOptions, response.data.pagingOptions)
      }).catch(this.handleAjaxError)
    },
    onSearchClick () {
      if (this.model.runAt && !this.isValidDateString(this.model.runAt)) {
        alert('진단 시작 시간이 올바르지 않습니다.')
        return
      }

      if (this.model.finishedAt && !this.isValidDateString(this.model.finishedAt)) {
        alert('진단 종료 시간이 올바르지 않습니다.')
        return
      }

      this.model.runSeconds = Number(this.model.runSeconds)

      if (isNaN(this.model.runSeconds) || this.model.runSeconds < 0) {
        alert('진단 로딩 시간이 올바르지 않습니다.')
        return
      }

      this.searchOptions = Object.assign({}, this.model)
      this.searchOptions.page = 1
      this.$router.push({ name: 'ManageReport', query: this.searchOptions })
    },
    isValidDateString (value) {
      if (value && value.length === 8) {
        const yearStr = value.substr(0, 4)
        const monthStr = value.substr(4, 2)
        const dayStr = value.substr(6, 2)
        const dateString = `${yearStr}-${monthStr}-${dayStr}`
        const regEx = /^\d{4}-\d{2}-\d{2}$/

        if (regEx.test(dateString)) {
          const date = new Date(dateString)

          if (!isNaN(date.getTime()) &&
            date.toISOString().slice(0, 10) === dateString) {
            return true
          }
        }
      }
      return false
    },
    onPageChange (page) {
      this.searchOptions.page = page
      this.$router.push({ name: 'ManageReport', query: this.searchOptions })
    },
    getSortClass (fieldName) {
      if (this.model.sortColumn === fieldName) {
        // sql 정렬과 ui는 반대
        return this.model.sortOrder === 'ASC' ? 'align_descending' : 'align_ascending'
      }
      return 'align_none'
    },
    setSort (fieldName) {
      if (this.model.sortColumn === fieldName) {
        if (this.model.sortOrder === 'ASC') {
          this.searchOptions.sortOrder = 'DESC'
        } else {
          this.searchOptions.sortOrder = 'ASC'
        }
      } else {
        this.searchOptions.sortColumn = fieldName
        this.searchOptions.sortOrder = 'ASC'
      }

      this.$router.push({ name: 'ManageReport', query: this.searchOptions })
    },
    onDateChanged (value, isStart) {
      let dateString = null

      if (value) {
        dateString = moment(value).format('YYYYMMDD')
      }

      if (isStart) {
        this.model.runAt = dateString
      } else {
        this.model.finishedAt = dateString
      }
    },
    onStartDateChanged (value) {
      this.onDateChanged(value, true)
    },
    onEndDateChanged (value) {
      this.onDateChanged(value, false)
    }
  }
}
</script>

<style>
.manage-report section{margin-top: 41px;}
.manage-report img{vertical-align: top;}
.manage-report .tbl_search{border-top: 1px solid #d0d0d0; border-left: 1px solid #d0d0d0; margin-bottom: 20px;}
.manage-report .tbl_search th{height: 33px; border-bottom: 1px solid #d0d0d0; border-right: 1px solid #d0d0d0; font-size: 13px; font-weight: bold; color: #111; background-color: #d5d5d5; text-align: center;}
.manage-report .tbl_search td{height: 41px; border-bottom: 1px solid #d0d0d0; border-right: 1px solid #d0d0d0; font-size: 12px; color: #333; padding-left: 9px; padding-right: 9px;}
.manage-report .tbl_search td span.h-bar{display: inline-block; width: 6px; height: 1px; background-color: #333; position: relative; top: -3px; margin: 0 5px;}
.manage-report .tbl_search td span.v-bar{margin: 0 10px;}
.manage-report .tbl_search input[type=text], .tbl_search input[type=number]{height: 28px; border-radius: 3px; border: solid 1px #ccc; padding-left: 10px; box-sizing: border-box; font-size: 12px; color: #333;}
.manage-report .tbl_search input[type=checkbox]{width: 12px; height: 12px; position: relative; top: 3px;}
.manage-report .tbl_search .mx-datepicker { width: 106px; float: left;}
.manage-report .tbl_search .mx-datepicker input[type=text] {width: 106px;}
.manage-report .tbl_search .date-range-box { text-align: left; }
.manage-report .tbl_search .date-range-box span.h-bar {float: left; margin-top: 16px;}
.manage-report .tbl_search .mx-calendar-content {height: auto;}
.manage-report .tbl_search .mx-clear-wrapper {top: 0;}
.manage-report .tbl_search input.input-full {width: 100%;}
.manage-report .tbl_search input.mg-right{margin-right: 3px;}
.manage-report .tbl_search input.mg-left{margin-left: 7px;}
.manage-report .tbl_search label{font-size: 12px; color: #333; position: relative; top: 1px;}
.manage-report td.btn{text-align: center; width: 164px;}
.manage-report td.btn button{width: 88px; height: 28px; border-radius: 3px; background-color: #2e4767; color: #fff; font-size: 13px; font-weight: 500; position: relative; top: -10px; padding: 0; line-height: 28px;}

.manage-report .result_wrap{overflow-x: scroll; margin-bottom: 20px;}
.manage-report .tbl_result{border-top: 1px solid #ccc; table-layout: fixed;}
.manage-report .tbl_result th{height: 34px; font-size: 13px; color: #111; border-bottom: 1px solid #ccc; text-align: center;}
.manage-report .tbl_result th a{color: #111; position: relative;}
.manage-report .tbl_result th a.align_none:after{content: url('../../../src/assets/images/ico_align_no.png'); width: 16px; height: 20px; display: block; position: absolute; top: -2px; right: -17px;}
.manage-report .tbl_result th a.align_ascending:after{content: url('../../../src/assets/images/ico_align_yes.png'); width: 20px; height: 20px; display: block; position: absolute; top: -4px; right: -20px;}
.manage-report .tbl_result th a.align_descending:after{content: url('../../../src/assets/images/ico_align_yes.png'); width: 20px; height: 20px; display: block; position: absolute; top: -1px; right: -20px; transform: rotate(180deg);}
.manage-report .tbl_result td{padding: 10px 0; border-bottom: 1px solid #ccc; font-size: 13px; color: #757575; text-align: center; position: relative; word-break: break-all; vertical-align: top;}
.manage-report .tbl_result td .ico_tooltip{display: inline-block; width: 15px; height: 20px; position: relative; top: 3px; left: 3px;}
.manage-report .tbl_result td .tooltip{visibility: hidden; width: 280px; background-color: #555; font-size: 12px; color: #fff; text-align: left; border-radius: 3px; padding: 5px 10px; position: absolute; z-index: 1; left: 100%; top: -10px; margin-left: 10px; opacity: 0; -webkit-transition: opacity 0.3s; transition: opacity 0.3s;}
.manage-report .tbl_result td .tooltip::after {content: ""; position: absolute; top: 10px; left: -5px; margin-left: -5px; border-width: 5px; border-style: solid; border-color: transparent #555 transparent transparent;}
.manage-report .tbl_result td .ico_tooltip:hover .tooltip{visibility: visible; opacity: 1;}
.manage-report .tbl_result td .btn_view{width: 54px; height: 22px; border-radius: 3px; background-color: #2e4767; font-size: 12px; padding: 0; line-height: 22px; font-weight: normal;}
.manage-report .tbl_result td.left {text-align: left;}
.manage-report .no-results {text-align: center; font-size: 13px;}

.manage-report .paging{height: 22px; position: relative; text-align: center;}
.manage-report .paging a{display: inline-block; width: 22px; height: 22px; line-height: 22px; margin: 0 2px;}
.manage-report .paging ul{display: inline-block; vertical-align: top; margin: 0 5px;}
.manage-report .paging ul li{display: inline-block;}
.manage-report .paging ul li a{font-size: 12px; color: #666; font-weight: normal; vertical-align: top; margin: 0;}
.manage-report .paging ul li a.active{color: #111; font-weight: bold;}

.manage-report .rotate img{transform: rotate(180deg);}
.manage-report ::-webkit-input-placeholder {color: #bdbdbd;}
.manage-report ::-moz-placeholder {color: #bdbdbd;}
.manage-report :-ms-input-placeholder {color: #bdbdbd;}
.manage-report :-moz-placeholder {color: #bdbdbd;}
</style>



// WEBPACK FOOTER //
// src/components/admin/ManageReport.vue